import axios from '../axios'
/**
 * 对战分数体操
 * @param {*} data
 */
export const macthGameScoreGyms = (data) => {
  return axios({
    url: '/match/webSiteTechnical/queryEurhythmicsRefeeScoreDetail/' + data.pkId + '/' + data.refeeType,
    method: 'get',
  })
}
/**
 * 对战分数跆拳道||街舞
 * @param {*} data
 */
export const macthGameScore = (data) => {
  return axios({
    url:
      '/match/webSiteTechnical/queryHipHopScoreDetail/' +
      data.pkId +
      '/' +
      data.round +
      '/' +
      data.fromRefee +
      '/' +
      data.scoreModle,
    method: 'get',
  })
}
/**
 * 对战场次
 * @param {*} data
 */
export const macthGamePeople = (data) => {
  return axios({
    url: '/match/webSiteTechnical/queryTechnical/' + data.matchId + '/' + data.matchField,
    method: 'get',
  })
}
/**
 * 图片上传
 * @param {*} data
 */
export const upload = (data) => {
  return axios({
    url: '/match/file/upload',
    method: 'post',
    data,
    headers: {
      isToken: false,
    },
  })
}
/**
 * 赛事列表
 * @param {*} data
 */
export const list = (data) => {
  return axios({
    url:
      '/match/match/list/' +
      data.agencyId +
      '/' +
      data.type +
      '/' +
      data.status +
      '/' +
      data.pid +
      '/' +
      data.programId +
      '/' +
      data.pageNum +
      '/' +
      data.pageSize,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询所有比赛时间列表
 * @param {*} data
 */
export const allMatchListTimeLine = (data) => {
  return axios({
    url: '/match/website/allMatchListTimeLine/' + data.agencyId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 根据时间查询赛事列表
 * @param {*} data
 */
export const matchListByTime = (data) => {
  return axios({
    url: '/match/website/matchListByTime',
    method: 'post',
    data,
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询平台总服务数据
 * @param {*} data
 */
export const platformMatchData = (data) => {
  return axios({
    url: '/match/websiteMain/platformMatchData',
    method: 'post',
    data,
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询平台数据
 * @param {*} data
 */
export const statisticalData = (data) => {
  return axios({
    url: '/match/websiteMain/statisticalData',
    method: 'get',
    data,
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询所有比赛时间列表
 * @param {*} data
 */
export const websiteMatchDetail = (data) => {
  return axios({
    url: '/match/website/websiteMatchDetail/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 获取赛事的小程序码
 * @param {*} data
 */
export const getMiniCode = (data) => {
  return axios({
    url: '/match/website/getMiniCode',
    method: 'post',
    data,
    headers: {
      isToken: false,
    },
  })
}

/**
 * 获取赛事的小程序码
 * @param {*} data
 */
export const queryMatchIdByDomain = (data) => {
  return axios({
    url: '/match/website/queryMatchIdByDomain/' + data.domain,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询赛事下的所有项目信息 matchId
 * @param {*} data
 */
export const queryMatchCombat = (data) => {
  return axios({
    url: '/match/website/queryMatchCombat/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询参赛数据（机构或个人） matchId
 * @param {*} data
 */
export const queryJoinAgencyData = (data) => {
  return axios({
    url: '/match/website/queryJoinAgencyData/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询机构参赛人员数据 {matchId}/{joinerId}/{type}
 * @param {*} data
 */
export const agencyJoinSimpleData = (data) => {
  return axios({
    url: '/match/website/agencyJoinSimpleData/' + data.matchId + '/' + data.agencyId + '/' + data.type,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询机构参赛人员数据 {matchId}/{joinerId}/{type}
 * @param {*} data
 */
export const queryAgencyMedalCombat = (data) => {
  return axios({
    url: '/match/website/queryAgencyMedalCombat/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询团体排名
 * @param {*} data
 */
export const queryAgencyMedalRank = (data) => {
  return axios({
    url: '/match/website/queryAgencyMedalRank',
    method: 'post',
    data,
  })
}

/**
 * 查询团体排名
 * @param {*} data
 */
export const downloadAgencyMedalRank = (data) => {
  return axios({
    url: '/match/website/downloadAgencyMedalRank',
    method: 'post',
    responseType: 'blob',
    headers: {
      isToken: false,
    },
    data,
  })
}
/**
 * 查询机构参赛人员数据 {matchId}/{joinerId}/{type}
 * @param {*} data
 */
export const queryMedalCombatRank = (data) => {
  return axios({
    url: '/match/website/queryMedalCombatRank/' + data.matchId + '/' + data.combatId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询赛事公告
 * @param {*} data
 */
export const matchNotices = (data) => {
  return axios({
    url: '/match/websiteMain/matchNotices/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询赛事公告详情 {id}
 * @param {*} data
 */
export const matchNoticesDetail = (data) => {
  return axios({
    url: '/match/websiteMain/matchNoticesDetail/' + data.id,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 *  下载EXcel奖牌榜
 * @param {*} data
 */
export const downloadMedalExcel = (data) => {
  return axios({
    url: '/match/website/downloadMedalExcel/' + data.matchId,
    method: 'get',
    responseType: 'blob',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 赛事运动员添加/编辑
 * @param {*} data
 */
export const playerSave = (data) => {
  return axios({
    url: '/match/player/save',
    method: 'post',
    data,
  })
}
/**
 * 删除赛事运动员
 * @param {*} data
 */
export const playerDelete = (data) => {
  return axios({
    url: '/match/player/delete/' + data.id,
    method: 'delete',
  })
}
/**
 * 删除团队成员
 * @param {*} data
 */
export const agencyStaffDel = (data) => {
  return axios({
    url: '/agency/agencyStaff/delStaff/' + data.agencyId + '/' + data.id,
    method: 'get',
  })
}

/**
 * 查询全部项目
 * @param {*} data
 */
export const programAll = (data) => {
  return axios({
    url: '/match/program/all',
    method: 'get',
  })
}

/**
 * 添加队伍队员信息
 * @param {*} data
 */
export const agencyStaffAdd = (data) => {
  return axios({
    url: '/agency/agencyStaff/addStaff',
    method: 'post',
    data,
  })
}

/**
 * 修改队伍队员信息
 * @param {*} data
 */
export const agencyStaffUpdate = (data) => {
  return axios({
    url: '/agency/agencyStaff/updateStaff',
    method: 'put',
    data,
  })
}

/**
 * 查询联赛、系列赛、运动会赛事详情 {matchId}
 * @param {*} data
 */
export const querySeriesMatchDetail = (data) => {
  return axios({
    url: '/match/webSiteMatchSeries/querySeriesMatchDetail/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询联赛、系列赛、运动会赛事详情 {matchId}
 * @param {*} data
 */
export const querySportsProgram = (data) => {
  return axios({
    url: '/match/webSiteMatchSeries/querySportsProgram/' + data.matchId,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询代表团报名
 * @param {*} data
 */
export const queryDelegation = (data) => {
  return axios({
    url: '/matchJoin/matchJoin/join/queryDelegation/' + data.matchId + '/' + data.agencyId,
    method: 'get',
  })
}

/**
 * 代表团报名
 * @param {*} data
 */
export const joinDelegation = (data) => {
  return axios({
    url: '/matchJoin/matchJoin/join/joinDelegation',
    method: 'post',
    data,
  })
}

/**
 * 查询联赛、系列赛、运动会的赛程
 * @param {*} data
 */
export const querySeriesMatchPlan = (data) => {
  return axios({
    url:
      'match/webSiteMatchSeries/querySeriesMatchPlan/' +
      data.matchId +
      '/' +
      data.time +
      '/' +
      data.pageNum +
      '/' +
      data.pageSize,
    method: 'get',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询联赛、系列赛、运动会的赛程
 * @param {*} data
 */
export const delegationList = (data) => {
  return axios({
    url: '/matchJoin/matchJoin/join/delegationList/' + data.accountId + '/' + data.matchId,
    method: 'get',
  })
}
/**
 * 查询项目名称数组对象
 * {matchId}
 * @param matchId
 * @returns {Promise | Promise<unknown>}
 */
export const combatNameList = (matchId) => {
  return axios({
    url: 'match/combat/combatNameList/' + matchId,
    method: 'GET',
  })
}

/**
 * 获取赛事组别信息
 * @param matchId
 * @returns {Promise | Promise<unknown>}
 */
export const queryCombatDetailGroup = (matchId) => {
  return axios({
    url: 'match/combatDetail/queryCombatDetailGroup/' + matchId,
    method: 'GET',
  })
}

/**
 * 按年龄返回查询机构队员
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const queryAgencyPlayerByAge = (data) => {
  return axios({
    url: 'match/player/queryAgencyPlayerByAge',
    method: 'POST',
    data,
  })
}

/**
 * 查询赛事组别信息
 * @param matchId
 * @param title
 * @returns {Promise | Promise<unknown>}
 */
export const queryCombatDetailNameByTitle = (matchId, agencyId, teamId, title) => {
  return axios({
    url: 'match/combatDetail/queryCombatDetailNameByTitle/' + matchId + '/' + agencyId + '/' + teamId + '/' + title,
    method: 'GET',
  })
}

/**
 * 查询项目兼项配置数据
 * @param matchId
 * @returns {Promise | Promise<unknown>}
 */
export const combatTermList = (matchId) => {
  return axios({
    url: 'match/combatTerm/list/' + matchId,
    method: 'GET',
  })
}

/**
 * 按项目报名类型分组查询
 * @returns {Promise | Promise<unknown>}
 */
export const groupAll = () => {
  return axios({
    url: 'match/program/groupAll',
    method: 'GET',
  })
}

/**
 * 查询平台目前已经存在的赛事类型
 * @returns {Promise | Promise<unknown>}
 */
export const getAllProgram = () => {
  return axios({
    url: '/match/websiteMain/programAll',
    method: 'GET',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 提交大众裁判
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const onlinePublic = (data) => {
  return axios({
    url: 'match/online/onlinePublic',
    method: 'POST',
    data,
  })
}
/*
 * 查询机构排行榜
 * @returns {Promise | Promise<unknown>}
 */
export const getAgencyRank = (data) => {
  return axios({
    url:
      '/match/website/findAgencyRankList/' +
      data.programId +
      '/' +
      data.province +
      '/' +
      data.year +
      '/' +
      data.name +
      '/' +
      data.type +
      '/' +
      data.pageNum +
      '/' +
      data.pageSize,
    method: 'GET',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询运动员排行榜
 * @returns {Promise | Promise<unknown>}
 */
export const getPlayRank = (data) => {
  return axios({
    url:
      '/match/website/findPlayerRankList/' +
      data.programId +
      '/' +
      data.province +
      '/' +
      data.year +
      '/' +
      data.name +
      '/' +
      data.pageNum +
      '/' +
      data.pageSize,
    method: 'GET',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 赛事专区 查询最近赛事
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const getEventMatch = (data) => {
  return axios({
    url: '/match/website/matchListByTime',
    method: 'POST',
    data,
  })
}

/**
 * 查询官网赛事专区时间轴
 * @returns {Promise | Promise<unknown>}
 */
export const programMatchListTimeLine = (data) => {
  return axios({
    url: '/match/website/programMatchListTimeLine/' + data.programId,
    method: 'GET',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 查询官网赛事专区内赛事数据
 * @returns {Promise | Promise<unknown>}
 */
export const programPageMatchList = (data) => {
  return axios({
    url:
      '/match/website/programPageMatchList/' +
      data.pageNum +
      '/' +
      data.pageSize +
      '/' +
      data.keyWord +
      '/' +
      data.programId +
      '/' +
      data.status,
    method: 'GET',
    headers: {
      isToken: false,
    },
  })
}

/**
 * 运动员技术统计
 * @returns {Promise | Promise<unknown>}
 */
export const playerTechnical = (data) => {
  return axios({
    url: '/userCenter/playerHome/playerTechnical/' + data.cardId + '/' + data.programId,
    method: 'GET',
  })
}

/**
 * 运动员运动生涯
 * @returns {Promise | Promise<unknown>}
 */
export const playerEvents = (data) => {
  return axios({
    url:
      '/userCenter/playerHome/playerEvents/' +
      data.cardId +
      '/' +
      data.programId +
      '/' +
      data.year +
      '/' +
      data.pageNo +
      '/' +
      data.pageSize,
    method: 'GET',
  })
}
/**
 * 查询区域信息
 * @param type
 * @param code
 */
export const areaInfo = (type, code) => {
  return axios({
    url: `/match/district/areaInfo/${type}/${code}`,
    method: 'GET',
    headers: {
      isToken: false,
    },
  })
}
/**
 * 查询订单金额
 * @param
 * @param
 */
export const queryMatchWebsiteAmount = () => {
  return axios({
    url: '/matchOa/manager/matchApply/queryMatchWebsiteAmount',
    method: 'GET',
  })
}
/**
 * 获取竞赛设备
 * @param type
 * @param code
 */
export const queryMatchEquipmentTypeAmount = (programId) => {
  return axios({
    url: `/matchOa/manager/matchAmount/queryMatchEquipmentTypeAmount/${programId}`,
    method: 'GET',
  })
}
/**
 * 赛事付款订单生成
 * @param matchName 赛事名称
 * @param logo 赛事logo
 * @param programId 赛事项目ID
 * @param contactName 联系人姓名
 * @param contactPhone 联系人手机号
 * @param directive 赛事规程
 * @param namedDaoba 是否以'道吧杯'冠名 0-否 1-是
 * @param countryCode 国家编码
 * @param provinceCode 省编码
 * @param cityCode 市编码
 * @param areaCode 区编码
 *
 */
export const matchApply = (data) => {
  return axios({
    url: '/matchOa/manager/matchApply/matchApply',
    method: 'POST',
    data,
  })
}
/**
 * 获取赛事订单状态
 * @param orderNo 订单号
 * @param
 *
 */
export const orderStatus = (data) => {
  return axios({
    url: '/matchOa/manager/matchApply/orderStatus',
    method: 'POST',
    data,
  })
}

/**
 * 获取是否是组委会成员
 * @param
 * @param
 *
 */
export const isMatchEmpower = (matchId) => {
  return axios({
    url: `/match/empower/isMatchEmpower/${matchId}`,
    method: 'GET',
  })
}

/**
 * 添加/编辑报送审核
 * @param
 *
 */
export const examineSave = (data) => {
  return axios({
    url: '/match/examine/save',
    method: 'POST',
    data,
  })
}
/**
 * 添加/编辑教练报送审核
 * @param
 *
 */
export const staffMsgSave = (data) => {
  return axios({
    url: '/agency/staffMsg/save',
    method: 'POST',
    data,
  })
}
/**
 * 查询
 * @param
 * @param
 *
 */
export const staffMsgList = (data) => {
  return axios({
    url: `/agency/staffMsg/list/${data.agencyId}`,
    method: 'GET',
  })
}
/**
 * 修改排序
 * @param
 * @param
 *
 */
export const updateStaffSort = (data) => {
  return axios({
    url: `/agency/staffMsg/updateSort/${data.id}` + '/' + data.sort,
    method: 'GET',
  })
}
/**
 * 查询
 * @param
 * @param
 *
 */
export const examineList = (data) => {
  return axios({
    url: `/match/examine/list/${data.agencyName}`,
    method: 'GET',
  })
}

/**
 * 查询
 * @param
 * @param
 *
 */
export const examineListByAccount = () => {
  return axios({
    url: `/match/examine/listByAccount`,
    method: 'GET',
  })
}

export const updIsFinals = (data) => {
  return axios({
    url: `/match/examine/updIsFinals/` + data.id,
    method: 'GET',
  })
}
/**
 * 删除
 * @param {*} data
 */
export const examineDelete = (data) => {
  return axios({
    url: '/match/examine/delete/' + data.id,
    method: 'delete',
  })
}

/**
 * 删除
 * @param {*} data
 */
export const staffMsgDelete = (data) => {
  return axios({
    url: '/agency/staffMsg/delete/' + data.id,
    method: 'delete',
  })
}

/**
 * 查询
 * @param
 * @param
 *
 */
export const findAccountList = (data) => {
  return axios({
    url:
      `/auth/sysAccount/findAccountList?pageNum=` +
      data.pageNum +
      '&pageSize=' +
      data.pageSize +
      '&keyword=' +
      data.keyword,
    method: 'GET',
  })
}

/**
 * 查询
 * @param
 * @param
 *
 */
export const managePlayerList = (data) => {
  return axios({
    url:
      `/match/examine/manageList?pageNum=` +
      data.pageNum +
      '&pageSize=' +
      data.pageSize +
      '&keyword=' +
      data.keyword +
      '&status=' +
      data.status,
    method: 'GET',
  })
}

/**
 * 查询
 * @param
 * @param
 *
 */
export const managePageList = (data) => {
  return axios({
    url: `/match/examine/managePageList`,
    method: 'POST',
    data,
  })
}

/**
 * 修改
 * @param
 * @param
 *
 */
export const updateEnabled = (data) => {
  return axios({
    url: `/auth/sysAccount/updateEnabled/` + data.id + '/' + data.enabled,
    method: 'PUT',
  })
}

/**
 * 修改昵称
 * @param
 * @param
 *
 */
export const updateNickname = (data) => {
  return axios({
    url: `/auth/sysAccount/updateNickname/` + data.id + '/' + data.unitName,
    method: 'PUT',
  })
}

/**
 * 资格审查不通过信息
 * @param {*} data
 */
export const examineCheckMsg = (data) => {
  return axios({
    url: '/match/examine/checkMsg',
    method: 'post',
    data,
  })
}

/**
 * 查询
 * @param
 * @param
 *
 */
export const manageStaffList = (data) => {
  return axios({
    url:
      `/agency/staffMsg/manageList?pageNum=` +
      data.pageNum +
      '&pageSize=' +
      data.pageSize +
      '&keyword=' +
      data.keyword +
      '&status=' +
      data.status,
    method: 'GET',
  })
}

/**
 * 资格审查不通过信息
 * @param {*} data
 */
export const staffCheckMsg = (data) => {
  return axios({
    url: '/agency/staffMsg/checkMsg',
    method: 'post',
    data,
  })
}

/**
 * 查询
 * @param
 * @param
 *
 */
export const taxpayerMsg = (data) => {
  return axios({
    url: `/match/taxpayerMsg/getMsg/` + data.matchId + '/' + data.agencyId,
    method: 'GET',
  })
}

/**
 * 添加或修改开票信息
 * @param {*} data
 */
export const taxpayerMsgSave = (data) => {
  return axios({
    url: '/match/taxpayerMsg/addOrUpdate',
    method: 'post',
    data,
  })
}

/**
 * 查询自己提交的裁判员信息
 * @param
 * @param
 *
 */
export const refereeSelfList = (data) => {
  return axios({
    url: `/match/refereeData/selfList?matchId=` + data.matchId,
    method: 'GET',
  })
}

/**
 * 添加
 * @param {*} data
 */
export const refereeSave = (data) => {
  return axios({
    url: '/match/refereeData/save',
    method: 'post',
    data,
  })
}

/**
 * 删除
 * @param
 * @param
 *
 */
export const refereeDel = (data) => {
  return axios({
    url: `/match/refereeData/delete/` + data.id + '/' + data.matchId,
    method: 'delete',
  })
}

/**
 * 查询授权的赛事裁判审核
 * @param
 * @param
 *
 */
export const refereeAuthList = () => {
  return axios({
    url: `/match/refereeData/authList`,
    method: 'GET',
  })
}

/**
 * 查询授权的赛事裁判审核
 * @param
 * @param
 *
 */
export const refereeList = (data) => {
  return axios({
    url: `/match/refereeData/list?matchId=` + data.matchId + '&status=' + data.status + '&keyword=' + data.keyword,
    method: 'GET',
  })
}

/**
 * 查询授权的赛事裁判审核
 * @param
 * @param
 *
 */
export const updateRefereeIsSelect = (data) => {
  return axios({
    url: `/match/refereeData/updateRefereeIsSelect/` + data.matchId + '/' + data.refereeId + '/' + data.isSelect,
    method: 'GET',
  })
}

/**
 * 资格审查不通过信息
 * @param {*} data
 */
export const refereeCheckMsg = (data) => {
  return axios({
    url: '/match/refereeData/checkMsg',
    method: 'post',
    data,
  })
}

/**
 * 机构修改简称
 * @param {*} data
 */
export const updateUnitNameAll = (data) => {
  return axios({
    url: '/agency/agencyInfo/updateUnitNameAll',
    method: 'post',
    data,
  })
}

/**
 * 查询省份
 * @param
 * @param
 *
 */
export const provinceList = () => {
  return axios({
    url: `/match/refereeAssign/provinceList`,
    method: 'GET',
  })
}

/**
 * 查询体能对战时间项目
 *
 */
export const matchExamDate = (matchId) => {
  return axios({
    url: `/match/bodyExamStandard/matchExamDate/${matchId}`,
    method: 'GET',
  })
}
/**
 * 查询体能对战列表
 *
 */
export const matchEventData = (data) => {
  return axios({
    url: `/match/bodyExamStandard/matchEvent`,
    data,
    method: 'POST',
  })
}
/**
 * 查询体能排行榜
 *
 */
export const bodyExamStandardMatchRank = (data) => {
  return axios({
    url: `/match/bodyExamStandard/matchRank`,
    data,
    method: 'POST',
  })
}

/**
 * @param {*} data
 */
export const downloadJoinAgencyPlayer = data => {
  return axios({
    url: '/match/download/downloadJoinAgencyPlayer/' + data.matchId + '/' + data.agencyId,
    method: 'get',
    responseType: 'blob',
    headers: {
      isToken: false,
    }
  })
}



// WEBPACK FOOTER //
// ./src/comm/http/modules/match.js